import { render, staticRenderFns } from "./properties-block-table.vue?vue&type=template&id=5c1278b1&scoped=true"
import script from "./properties-block-table.vue?vue&type=script&lang=js"
export * from "./properties-block-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1278b1",
  null
  
)

export default component.exports